/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSevereColdIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-severe-cold"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M20 10.32Q19.43 10.32 19.05 9.95Q18.68 9.57 18.68 9Q18.68 8.45 19.05 8.06Q19.43 7.67 20 7.67Q20.55 7.67 20.94 8.06Q21.32 8.45 21.32 9Q21.32 9.57 20.94 9.95Q20.55 10.32 20 10.32ZM9.68 19.18L8.3 20.55Q7.95 20.93 7.4 20.93Q6.85 20.93 6.47 20.52Q6.08 20.15 6.08 19.61Q6.08 19.07 6.47 18.68L9.68 15.47L9.68 14.32L8.53 14.32L5.3 17.55Q4.95 17.93 4.4 17.93Q3.85 17.93 3.48 17.52Q3.08 17.15 3.08 16.61Q3.08 16.07 3.48 15.68L4.83 14.32L2.98 14.32Q2.42 14.32 2.05 13.95Q1.68 13.57 1.68 13Q1.68 12.45 2.05 12.06Q2.42 11.68 3 11.68L4.83 11.68L3.45 10.32Q3.08 9.95 3.08 9.41Q3.08 8.88 3.48 8.47Q3.85 8.1 4.39 8.1Q4.92 8.1 5.33 8.47L8.53 11.68L9.68 11.68L9.68 10.53L6.45 7.33Q6.08 6.95 6.08 6.41Q6.08 5.88 6.47 5.47Q6.85 5.1 7.39 5.1Q7.92 5.1 8.32 5.47L9.68 6.83L9.68 5Q9.68 4.45 10.05 4.06Q10.43 3.67 11 3.67Q11.55 3.67 11.94 4.06Q12.32 4.45 12.32 5L12.32 6.83L13.68 5.47Q14.05 5.1 14.59 5.1Q15.13 5.1 15.53 5.47Q15.9 5.88 15.9 6.41Q15.9 6.95 15.53 7.33L12.32 10.53L12.32 11.68L19 11.68Q19.55 11.68 19.94 12.06Q20.32 12.45 20.32 13Q20.32 13.57 19.94 13.95Q19.55 14.32 19 14.32L17.18 14.32L18.52 15.7Q18.9 16.05 18.9 16.6Q18.9 17.15 18.52 17.52Q18.13 17.93 17.59 17.93Q17.05 17.93 16.68 17.52L13.47 14.32L12.32 14.32L12.32 15.47L15.53 18.7Q15.9 19.05 15.9 19.6Q15.9 20.15 15.53 20.52Q15.13 20.93 14.59 20.93Q14.05 20.93 13.68 20.52L12.32 19.18L12.32 21.02Q12.32 21.57 11.94 21.95Q11.55 22.32 11 22.32Q10.43 22.32 10.05 21.95Q9.68 21.57 9.68 21ZM20 6.67Q19.43 6.67 19.05 6.3Q18.68 5.92 18.68 5.35L18.68 2.35Q18.68 1.8 19.05 1.41Q19.43 1.02 20 1.02Q20.55 1.02 20.94 1.41Q21.32 1.8 21.32 2.35L21.32 5.38Q21.32 5.92 20.94 6.3Q20.55 6.67 20 6.67Z" fill={color} />
    </svg>
  );
}
